/* eslint-disable node/no-deprecated-api */
import punycode from 'punycode'

export const readCookie = name => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))

  if (match) {
    return match[2]
  }
  return null
}

export const normaliseDomain = (domain) => {
  if (domain && domain.length) return punycode.toASCII(domain).replace(/\./g, ',')
  else return ''
}

export const denormaliseDomain = (domain) => {
  if (domain && domain.length) return punycode.toUnicode(domain.replace(/,/g, '.'))
  else return ''
}
